export const LOGIN = "/auth/login/";
export const LOGOUT = "/auth/logout/";
export const ME = "/me/";
export const USER = "/users/";
export const USER_FULLLIST = "/users/FullList";
export const PERMISSION = "/users/permissions_visible/";
export const PERMISSION_USER = "/users/add_permissions_to_user/";
export const PERMISSION_GROUP = "/users/add_permissions_to_group/";
export const ROL = "/roles/";
export const ROL_FULLLIST = "/roles/FullList";
export const ACCOUNT = "/account/account/";
export const ACCOUNT_FULLLIST = "/account/account/FullList";
export const CAMPAIGN = "/campaign/campaign/";
export const CAMPAIGN_FULLLIST = "/campaign/campaign/FullList";
export const LENGS = "/lengs/lengs/";
export const LENGS_FULLLIST = "/lengs/lengs/FullList";
export const DASHBOARD = "/dashboard/";
export const CONTACTS = "/contact/contacto/";
export const CONTACTS_GET_USER = "/contact/contacto/get_contact_user/";
export const CONTACTS_FULLLIST = "contact/contacto/FullList/";
export const CONTACTS_DATA = "/contact/datoContacto/";
export const CONTACTS_DATA_FULLLIST = "/contact/datoContacto/FullList";
export const CONTACTS_DOCUMENT = "/contact/documentoContacto/";
export const CONTACTS_DOCUMENT_FULLLIST = "/contact/documentoContacto/FullList";
export const CONTACTS_AGENT = "/contacts/Get_agent/";
export const GRUPOTECNICO = "/contact/GrupoTecnico/"
export const GRUPOTECNICO_FULLLIST = "/contact/GrupoTecnico/FullList/"
export const CASOS_FULLLIST = "/casos/casos/FullList/"
export const CASOS = "/casos/casos/"
export const CASOSDETALLES_FULLLIST = "/casos/casosDetalles/FullList/"
export const CASOSDETALLES = "/casos/casosDetalles/"
export const INFORMES_FULLLIST = "/informe/informe/FullList";
export const INFORMES = "/informe/informe/";
export const INFORMESPORCASO = "/informe/informeporcaso/por-caso/";
export const INFORMEIMAGE = "/informe/informeImage/";
export const LEADS_FULLLIST = "/leads/leads/FullList";
export const LEADS = "/leads/leads/";
export const AGENDA_FULLLIST = "/agenda/agenda/FullList";
export const AGENDA = "/agenda/agenda/";
export const COMPRAS_FULLLIST = "/factura/compra";
export const COMPRAS = "/factura/compra/";